import { useMutation, useQueryClient } from "@tanstack/react-query";

import { IdentitySettingsResponse } from "./useIdentitySettings";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";

export interface WorkosSyncResponse {
  sync: {
    workos_organization_id: string;
    workos_sso_connection_id: string | null;
    workos_directory_id: string | null;
    protocol: string | null;
    sso_connection_status: string;
    directory_status: string;
    changes: Record<string, unknown>;
  };
  settings: IdentitySettingsResponse["settings"];
}

export const useSyncWorkos = (organizationId: number) => {
  const userToken = useAuth()?.userToken;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () =>
      fetch(ENDPOINTS.identity.sync_workos(organizationId), {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken ?? ""}`,
        },
      }).then(handleResponse) as Promise<WorkosSyncResponse>,
    onSuccess: response => {
      queryClient.setQueryData<IdentitySettingsResponse>(
        ["identity", "settings", organizationId],
        previous => ({
          feature_enabled: previous?.feature_enabled ?? true,
          settings: response.settings ?? previous?.settings ?? null,
        }),
      );
    },
  });
};
